

//短信管理
import shortmessageindex from '@/views/shortmessage/shortmessageindex';
import shortmessageadd from '@/views/shortmessage/shortmessageadd';
import shortmessagelist from '@/views/shortmessage/shortmessagelist';
import shortmessagewholelist from '@/views/shortmessage/shortmessagewholelist';
//识别管理 
import Identificationmanagementindex from '@/views/Identificationmanagement/Identificationmanagementindex';
import Identificationmanagementadd from '@/views/Identificationmanagement/Identificationmanagementadd';
import Identificationmanagementschool from '@/views/Identificationmanagement/Identificationmanagementschool';
import Identificationmanagementlist from '@/views/Identificationmanagement/Identificationmanagementlist';
//放学套餐
import schoolRoadTeamPackageindex from '@/views/schoolRoadTeamPackage/schoolRoadTeamPackageindex';
import schoolRoadTeamPackageadd from '@/views/schoolRoadTeamPackage/schoolRoadTeamPackageadd';
import schoolRoadTeamPackageeidt from '@/views/schoolRoadTeamPackage/schoolRoadTeamPackageeidt';
import schoolRoadTeamPackageinfo from '@/views/schoolRoadTeamPackage/schoolRoadTeamPackageinfo';
import schoolRoadTeamPackageimglist from '@/views/schoolRoadTeamPackage/schoolRoadTeamPackageimglist';
// 农行活动管理
import abcActivityList from '@/views/abcActivityManagement/abcActivityList';
import abcActivityAddEdit from '@/views/abcActivityManagement/abcActivityAddEdit';

import resourceusageindex from '@/views/resourceusage/resourceusageindex';
import resourceusageinfo from '@/views/resourceusage/resourceusageinfo';

export default [
  // 系统数据
  {
    path: 'systemoperation',
    redirect: 'systemoperation/shortmessage/shortmessageindex'
  },
  {
    path: 'systemoperation/resourceusage/resourceusageindex',
    component: resourceusageindex
  }, 
  {
    path: 'systemoperation/resourceusage/resourceusageinfo',
    component: resourceusageinfo
  },
  {
    path: 'systemoperation/shortmessage/shortmessageindex',
    component: shortmessageindex
  }, 
  {
    path: 'systemoperation/shortmessage/shortmessageadd',
    component: shortmessageadd
  },
  {
    path: 'systemoperation/shortmessage/shortmessagelist',
    component: shortmessagelist
  },
  {
    path: 'systemoperation/shortmessage/shortmessagewholelist',
    component: shortmessagewholelist
  },
  {
    path: 'systemoperation/Identificationmanagement/Identificationmanagementindex',
    component: Identificationmanagementindex
  },
  {
    path: 'systemoperation/Identificationmanagement/Identificationmanagementadd',
    component: Identificationmanagementadd
  },
  {
    path: 'systemoperation/Identificationmanagement/Identificationmanagementlist',
    component: Identificationmanagementlist
  },
  {
    path: 'systemoperation/Identificationmanagement/Identificationmanagementschool',
    component: Identificationmanagementschool
  },
  {
    path: 'systemoperation/schoolRoadTeamPackage/schoolRoadTeamPackageindex',
    component: schoolRoadTeamPackageindex
  },
  {
    path: 'systemoperation/schoolRoadTeamPackage/schoolRoadTeamPackageadd',
    component: schoolRoadTeamPackageadd
  },
  {
    path: 'systemoperation/schoolRoadTeamPackage/schoolRoadTeamPackageeidt',
    component: schoolRoadTeamPackageeidt
  },
  {
    path: 'systemoperation/schoolRoadTeamPackage/schoolRoadTeamPackageimglist',
    component: schoolRoadTeamPackageimglist
  },
  {
    path: 'systemoperation/schoolRoadTeamPackage/schoolRoadTeamPackageinfo',
    component: schoolRoadTeamPackageinfo
  },
    {
        path: 'systemoperation/abcActivityManagement/abcActivityList',
        component: abcActivityList
    },
    {
        path: 'systemoperation/abcActivityManagement/abcActivityAddEdit',
        component: abcActivityAddEdit
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/systemoperation.js